export default {
  subscribers: {
    title: "Абоненты",
    searchSubscribers: {
      modal: {
        title: "Параметры поиска абонентов"
      },
      form: {
        abcode: "Лицевой счет",
        fio: "ФИО абонента",
        region: "Район",
        street: "Улица",
        house: "Дом",
        corpHouse: "Корпус дома",
        flat: "Квартира",
        ncount: "№ счетчика",
        docnumber: "ИНН",
        eic: "EIC",
        dateBegin: "Л/счет открыт",
        dateEnd: "закрыт",
        nact: "№ акта",
        accountNumber: "№ счета",
        fiofiz: "Фамилия физ. лица",
        phone: "Телефон",
        numberhouses: "№ домового счетчика"
      }
    }
  }
};
